/**
 * The largest count up to `max` for which `fits` holds, stepping one at a
 * time from `estimate`: up while the next count still fits, or down until one
 * does. `fits` is expected to hold up to some limit and not past it, and the
 * estimate to sit within a character or two of that limit, so this costs a
 * few calls rather than a search. When no count fits it returns 0.
 *
 * `ClampedText` estimates a label's fit from the full text and an ellipsis
 * measured on its own, which can land a fraction of a pixel either side of
 * the label as rendered; `fits` tries the label as it will render.
 */
export function longestFit(estimate: number, max: number, fits: (count: number) => boolean) {
  let count = Math.min(Math.max(estimate, 0), max);
  if (fits(count)) {
    while (count < max && fits(count + 1)) count += 1;
  } else {
    while (count > 0) {
      count -= 1;
      if (fits(count)) break;
    }
  }
  return count;
}
